import "Styles/templates/page.ksx.scss";

import collectionListingApp from '../vue/collection-listing/index';

collectionListingApp();